import { render, staticRenderFns } from "./ImportExportPricesForm.vue?vue&type=template&id=675ba835&scoped=true&"
import script from "./ImportExportPricesForm.vue?vue&type=script&lang=js&"
export * from "./ImportExportPricesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ba835",
  null
  
)

export default component.exports